<template>
    <div style="padding-top: 50px;">
        <div class="columns">
            <div class="column has-text-centered">
                <h1 class="title">Jibaiseki</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <datetime
                                    input-class="input"
                                    v-model="lot_date_from"
                                    :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                    type="date"
                                    value-zone="local"
                                    zone="local"
                                    placeholder="Date from:"
                            ></datetime>
                        </div>
                        <div class="field">
                            <datetime
                                    input-class="input"
                                    v-model="lot_date_to"
                                    :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                    type="date"
                                    value-zone="local"
                                    zone="local"
                                    placeholder="Date to:"
                            ></datetime>
                        </div>
                        <div class="field">
                            <button class="button is-primary" @click="search()">
                                <span class="icon">
                                    <i class="fas fa-search"></i>
                                </span>
                                <span>Search</span>
                            </button>
                            <button class="button"  @click="clearForm()">Clear</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <table class="table is-responsive-table is-fullwidth is-scrollable is-striped">
                    <thead>
                        <tr>
                            <th><span @click="setOrder('lot_date')" class="link">Date</span></th>
                            <th><span @click="setOrder('auction_name')" class="link">Auction</span></th>
                            <th><span @click="setOrder('bid')" class="link">#Lot</span></th>
                            <th><span @click="setOrder('company')" class="link">Make</span></th>
                            <th><span @click="setOrder('model_name_en')" class="link">Model</span></th>
                            <th><span @click="setOrder('model_type_en')" class="link">Chassis</span></th>
                            <th><span @click="setOrder('model_year_en')" class="link">Year</span></th>
                            <th><span @click="setOrder('jibaiseki')" class="link">Jibaiseki</span></th>
                            <th><span @click="setOrder('expected_exportation')" class="link">EDE</span></th>
                            <th>Status</th>
                            <th><span @click="setOrder('jibaiseki_applied')" class="link">Applied</span></th>
                            <th><span @click="setOrder('jibaiseki_refunded')" class="link">Refunded</span></th>
                            <th>Scan</th>
                        </tr>
                    </thead>
                    <tbody>
                        <jibaiseki-table-row v-for="car in cars" :car="car"></jibaiseki-table-row>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="columns">
            <div class="column has-text-centered">
                <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{ getFirstPage }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                        <li><a class="pagination-link" v-if="getCurrentPage > 1" @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                        <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{ getCurrentPage }}</a></li>
                        <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"  @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                        <li><span class="pagination-ellipsis" v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                        <li><a class="pagination-link" @click="changePage(getLastPage)" v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import JibaisekiTableRow from './JibaisekiTableRow'
    export default {
        components: {
            JibaisekiTableRow,
            Datetime
        },
        computed: {
            lot_date_from: {
                get() {
                    return this.$store.getters.getCarsQuery.lot_date_from
                },
                set(value) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'lot_date_from', value: value })
                }
            },
            lot_date_to: {
                get() {
                    return this.$store.getters.getCarsQuery.lot_date_to
                },
                set(value) {
                    this.$store.dispatch('setCarsQueryFieldValue', { field: 'lot_date_to', value: value })
                }
            },
            cars() {
                return this.$store.getters.getCars
            },
            isLoading() {
                return false
            },
            isLastPage() {
                return false
            },
            getCurrentPage() {
                return this.$store.getters.getCurrentCarsPage
            },
            getFirstPage() {
                return this.$store.getters.getCarsFirstPage
            },
            getLastPage() {
                return this.$store.getters.getLastCarsPage
            },
            isLastPage() {
                return this.$store.getters.isLastCarsPage
            },
        },
        methods: {
            clearForm() {
                this.$store.dispatch('clearCarsQuery')
                this.$store.dispatch('setCarsQueryFieldValue', { field: 'shaken_date', value: 1})
                this.$store.dispatch('fetchCars')
            },
            search() {
                this.$store.dispatch('fetchCarsWithSearchQuery')
            },
            changePage(page) {
                this.$store.dispatch('loadMoreCars', page)
            },
            setOrder(column) {
                this.$store.getters.getCarsOrderType === 'ASC' ? this.$store.dispatch('setCarsNewOrderType', 'DESC') : this.$store.dispatch('setCarsNewOrderType', 'ASC')
                this.$store.dispatch('setCarsNewOrderColumn', column)
                this.$store.dispatch('fetchCars')
            }
        },
        mounted() {
            this.$store.dispatch('clearCarsQuery')
            this.$store.dispatch('setCarsQueryFieldValue', { field: 'shaken_date', value: 1})
            this.$store.dispatch('fetchCars')
        },
    }
</script>

<style scoped>
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .table-container {
        padding-top: 20px;
        max-width: 100%;
        overflow: -moz-scrollbars-vertical;
        overflow-y: scroll;
    }
    .is-responsive-table th {
        font-size: small;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Jibaiseki/JibaisekiList.vue